module.exports = __webpack_public_path__ + "img/logo.39fad51d.png";